const clientId =
  "736771455123-ttjjkfnroislf3r41m0ct2hhc1f8deh1.apps.googleusercontent.com";

export function initializeGoogleSignin(onSessionInit: (token: string) => void) {
  google.accounts.id.initialize({
    client_id: clientId,
    callback: (response) => onSessionInit(response.credential),
    auto_select: true,
  });
}

export function logout_google() {
  // This will invoke immediately if it's in the same session that was used to login.
  // Otherwise, it's a no-op, which is fine for our purposes
  google?.accounts?.id?.disableAutoSelect();
}

export type LoginCallback = (token: string) => Promise<boolean>;
